import Reveal from "@/components/base/Reveal";
import { partners } from "@/mocks/partners";

export default function CompanyHighlight() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <div className="mb-4 flex items-center justify-center gap-3 font-label text-xs font-semibold uppercase tracking-[0.22em] text-primary-300">
              <span className="h-px w-8 bg-current opacity-60" />
              Partner Highlight
            </div>
            <h2 className="text-2xl font-bold leading-tight text-background-50 md:text-4xl">
              The Companies Behind the Collaboration
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
              KAL LORD'S, ZERO21 and DJT — three technology companies, each bringing a distinct
              strength together into one electric future.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {partners.map((partner, index) => (
            <Reveal key={partner.key} delay={index * 0.1}>
              <article className="group flex h-full flex-col items-center rounded-lg border border-background-50/10 bg-background-50/5 p-7 text-center transition-colors duration-300 hover:border-primary-400/60 hover:bg-background-50/10">
                <div className="flex h-20 w-full items-center justify-center rounded-md bg-background-50 p-4">
                  <img
                    src={partner.logo}
                    alt={`${partner.name} logo`}
                    title={`${partner.name} - EV retrofit technology partner`}
                    className="h-full w-auto max-w-[160px] object-contain"
                  />
                </div>
                <h3 className="mt-6 font-heading text-xl font-extrabold text-background-50">
                  {partner.name}
                </h3>
                <p className="mt-2 font-label text-[11px] font-semibold uppercase tracking-[0.16em] text-primary-300">
                  {partner.tagline}
                </p>
                <p className="mt-4 text-sm leading-relaxed text-background-200">{partner.role}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}